@if (type === "drop") {
    <div class="avatar-wrapper mx-2">
        <div
            class="drop-avatar"
            [ngClass]="{
                tiny: size === 'tiny',
                small: size === 'small',
                smaller: size === 'smaller',
                medium: size === 'medium',
                large: size === 'large',
                big: size === 'big',
                bigger: size === 'bigger',
                huge: size === 'huge',
                empty: !user?.id && !photo && showEmpty,
                'with-shadow': withShadow,
                highlight: highlight,
                rotating: loading,
            }"
        >
            <div class="drop-avatar-bg">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="225"
                    height="225.194"
                    viewBox="0 0 225 225.194"
                >
                    <g transform="translate(-10568.141 -563.702)">
                        <path
                            id="Path_879"
                            data-name="Path 879"
                            d="M-2163.471,1216.279c-53.627-.344-99.983-38.425-110.325-90.9a110.761,110.761,0,0,1-2.118-21.361c-.008-7.966,5.732-14.066,13.413-14.22,7.748-.156,13.9,5.882,13.987,13.956a82.126,82.126,0,0,0,9.088,37.79c13.142,25.115,33.625,40.644,61.606,45.579,24.528,4.326,46.919-1.411,66.56-16.649,17.839-13.839,28.811-32.119,31.814-54.558,4.355-32.538-6.735-59.272-32.276-79.726-14.272-11.43-30.942-17.066-49.276-17.593-1.165-.033-2.337-.019-3.492-.15-7.705-.875-13.111-7.074-12.672-14.4A13.882,13.882,0,0,1-2163,991.086a110.53,110.53,0,0,1,43.43,8.887c27.466,11.909,47.354,31.607,59.415,58.964a108.107,108.107,0,0,1,8.862,53c-2.338,29.05-14.148,53.65-35.3,73.615a108.733,108.733,0,0,1-59.243,28.927C-2151.666,1215.38-2157.589,1215.7-2163.471,1216.279Z"
                            transform="translate(12844.056 -427.384)"
                            [attr.fill]="dropColor"
                        />
                    </g>
                </svg>
            </div>

            <ng-container [ngTemplateOutlet]="avatar"></ng-container>
        </div>
    </div>
}

@if (type === "circle") {
    <ng-container [ngTemplateOutlet]="avatar"></ng-container>
}
<ng-template #avatar>
    <div
        class="avatar {{ className }}"
        [ngClass]="{
            tiny: type === 'circle' && size === 'tiny',
            small: type === 'circle' && size === 'small',
            smaller: type === 'circle' && size === 'smaller',
            medium: type === 'circle' && size === 'medium',
            large: type === 'circle' && size === 'large',
            big: type === 'circle' && size === 'big',
            bigger: type === 'circle' && size === 'bigger',
            huge: type === 'circle' && size === 'huge',
            empty: !user?.id && !photo && showEmpty,
            'with-shadow': withShadow,
        }"
    >
        @if ((!user?.image || imageError) && !photo && !label?.length) {
            <small class="avatar-initial">
                {{ initials }}
            </small>
        }

        @if (!user?.id && (!photo || imageError || !imageLoaded)) {
            <small
                class="text-uppercase text-white text-nowrap"
                [attr.aria-label]="user?.name || 'User'"
                >{{ initials }}</small
            >
        }

        @if ((photo || user?.image?.length) && !imageError) {
            <img
                [src]="
                    (photo || user?.image) +
                    (urlWidth && urlResize ? '?w=' + urlWidth : '')
                "
                class="h-100 w-100"
                [alt]="user?.name ?? 'User'"
                [class.d-none]="!imageLoaded"
                (load)="imageLoaded = true"
                (error)="imageError = true"
            />
        }

        @if (selected) {
            <i class="selected fa-solid fa-check fa-fw fa-4x text-success"></i>
        }

        @if (enableRemoving && (photo?.length || user?.image?.length)) {
            <i
                class="fa fa-fw fa-times text-danger remove-photo"
                [title]="removingTitle"
                (click)="onRemoveClicked($event)"
            ></i>
        }

        <ng-content></ng-content>

        @if (status === true || status === false) {
            <span
                class="status rounded-circle align-middle mr-1 position-absolute"
                [class.bg-success]="status === true"
                [class.bg-secondary]="status === false"
                [attr.title]="
                    status === true
                        ? 'Online'
                        : status === false
                          ? 'Offline'
                          : null
                "
            ></span>
        }
    </div>
</ng-template>
